import { FilterField } from "~/features/filter";
import { SubdivisionStatus } from "~/schemas/generated/graphql";

import { useParentSubdivisionOptions } from "./useParentSubdivisionOptions";

type Translate = (key: string) => string;

export const subdivisionFilterFields = (t: Translate): FilterField[] => [
  {
    name: "code",
    type: "input",
    label: t("editorSubdivision.code"),
  },
  {
    name: "name",
    type: "input",
    label: t("editorSubdivision.name"),
  },
  {
    name: "status",
    type: "select",
    label: t("editorSubdivision.status"),
    options: Object.values(SubdivisionStatus).map((item) => ({
      value: item,
      label: t(`editorSubdivision.${item}`),
    })),
  },
  {
    name: "parentSubdivision",
    type: "select",
    label: t("editorSubdivision.IncludedInDivision"),
    optionsHook: useParentSubdivisionOptions,
  },
];
